import { createSlice } from '@reduxjs/toolkit'

export const sidebarSizeSlice = createSlice({
    name: 'sidebar',
    initialState: {
        value: 'lg',
    },
    reducers: {
        setSidebarSize: (state, action) => {
            if (document.documentElement) {
                document.documentElement.setAttribute("data-sidebar-size", action.payload)
            }
            state.value = action.payload
        },
        // New reducer to expand a sidebar item
        expandSidebarItem: (state, action) => {
            // If the item isn't already in the expanded items list, add it
            if (!state.expandedItems.includes(action.payload)) {
                state.expandedItems.push(action.payload);
            }

            // Trigger any DOM manipulations that might be needed
            // This would be handled in a useEffect in your components
            // that listens for changes to the expandedItems array
        },
        // New reducer to collapse a sidebar item
        collapseSidebarItem: (state, action) => {
            // Remove the item from the expanded items list
            state.expandedItems = state.expandedItems.filter(
                item => item !== action.payload
            );
        },
        // Optional: Reset all expanded items
        resetExpandedItems: (state) => {
            state.expandedItems = [];
        },
        // Optional: Set multiple items as expanded at once
        setExpandedItems: (state, action) => {
            state.expandedItems = action.payload;
        }
    }
})

export const {
    setSidebarSize,
    expandSidebarItem,
    collapseSidebarItem,
    resetExpandedItems,
    setExpandedItems
} = sidebarSizeSlice.actions

// Selector to check if an item is expanded
export const selectIsItemExpanded = (state, itemId) =>
    state.sidebar.expandedItems.includes(itemId);

// Selector to get all expanded items
export const selectExpandedItems = (state) => state.sidebar.expandedItems;
export default sidebarSizeSlice.reducer
